export default __webpack_public_path__ + "static/assets/bab290842e3b1a1622b0703dc837d2e1.png";